export enum ProjectStepLinkType {
  OLD_FINISH_TO_START = 'OLD_FINISH_TO_START',
  FINISH_TO_START = 'FINISH_TO_START',
  START_TO_START = 'START_TO_START',
  FINISH_TO_FINISH = 'FINISH_TO_FINISH',
  START_TO_FINISH = 'START_TO_FINISH',
}
